import React from "react";
import StyledH3Heading from "../../common/components/styledH3Heading/styledH3Heading.tsx";
import StyledLgText from "../../common/components/styledLgText/StyledLgText.tsx";
import Button from "../button/Button.tsx";
import { useNavigate } from "react-router-dom";
import UseAuth from "../../utils/use-auth.ts";

const HomeCard = ({ imgSrc, headingContent, paraContent }) => {
  const { user } = UseAuth();
  const navigate = useNavigate();

  return (
    <div className="group w-full p-8 mt-10 gap-5 flex flex-col justify-start items-center rounded-2xl bg-white text-center self-stretch border border-gray-100 shadow-soft hover:shadow-card transition-all duration-300 hover:-translate-y-1">
      <div className="w-[55%] mx-auto overflow-hidden rounded-xl">
        <img className="w-full transition-transform duration-500 group-hover:scale-[1.03]" src={imgSrc} alt="Card image" />
      </div>

      <StyledH3Heading
        children={headingContent}
        fontColor={"text-blue text-xl font-semibold w-[80%] mx-auto tracking-tight"}
      />

      <StyledLgText children={paraContent} fontColor={"text-lightBlack text-[15px] leading-relaxed w-[92%] mx-auto"} />
      <div className="mt-2">
        <Button
          className="!w-auto !px-10"
          children={"Try Now"}
          onClick={() => navigate(user?.id ? "/chats" : "/signup")}
        />
      </div>
    </div>
  );
};

export default HomeCard;
